import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AppTextService } from '@fi-shared/app-text';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { OtherSettingsService } from '@fi-app/other-settings/other-settings.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { IOtherSettingsSmtpServer } from '@fi-app/other-settings/other-settings';
import { SmtpEncryptionMethod } from '@fi-app/other-settings/other-settings-smtp-edit/smtp-encryption-method';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-other-settings-smtp-edit',
    templateUrl: './other-settings-smtp-edit.component.html',
    styleUrls: ['./other-settings-smtp-edit.component.scss', '../other-settings-shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-other-settings-smtp-edit' },
    standalone: false,
})
export class OtherSettingsSmtpEditComponent implements OnInit {
    @Input() smtpServer: IOtherSettingsSmtpServer;

    EditTabs: EditTabsModel;

    SmtpEncryptionMethods = Object.keys(SmtpEncryptionMethod).map((key) => SmtpEncryptionMethod[key]);
    testEmailRecipient = '';
    encryptionMethod: string;

    constructor(
        private appTextService: AppTextService,
        private saveChangesWarningService: SaveChangesWarningService,
        private otherSettingsService: OtherSettingsService,
        private fiLoadingService: LoadingService,
        private stateService: FiStateService,
        private pageTitleService: PageTitleService,
        private fiDialogsService: FiDialogsService,
    ) {}

    ngOnInit() {
        this.EditTabs = new EditTabsModel(this.appTextService.get('other_settings.smtp_server_settings'));
        this.EditTabs.Tabs.push(
            new EditTabModel(this.appTextService.get('common.general'), this.appTextService.get('common.general')),
        );
        this.saveChangesWarningService.start(() => this.smtpServer);
        this.pageTitleService.setTitleByTextId('other_settings.smtp_server_settings');

        this.encryptionMethod = this.smtpServer.EnableSSL ? SmtpEncryptionMethod.SSL : SmtpEncryptionMethod.None;
    }

    save() {
        this.fiLoadingService.trackPromise(this.otherSettingsService.saveSmtpServer(this.smtpServer)).then(() => {
            this.saveChangesWarningService.stop();
            this.stateService.go(FiStateNames.OtherSettings.List);
        });
    }

    testConfiguration($event: MouseEvent) {
        $event.preventDefault();
        this.fiLoadingService
            .trackPromise(this.otherSettingsService.testSmtpServer(this.smtpServer, this.testEmailRecipient))
            .then((response) => {
                if (response.result) {
                    this.fiDialogsService.notify({
                        headerText: this.appTextService.get('other_settings.smtp_test'),
                        messageText: this.appTextService.get('other_settings.smtp_test_passed'),
                    });
                } else {
                    this.fiDialogsService.error({
                        headerText: this.appTextService.get('other_settings.smtp_test'),
                        messageText:
                            this.appTextService.get('other_settings.smtp_test_failed') +
                            '<br><br>' +
                            response.errorMessage,
                    });
                }
            });
    }

    encryptionMethodChanged($event: string) {
        this.smtpServer.EnableSSL = $event === SmtpEncryptionMethod.SSL;
        //this.smtpServer.Port = $event === SmtpEncryptionMethod.SSL ? 465 : 25;
    }
}
